export default __webpack_public_path__ + "static/media/49.2edf6882.png";